<template>
    <transition name="modal">
        <div class="bast-modal-mask">
            <div class="bast-modal-wrapper" @click="$emit('closeModal')">
                <div class="bast-modal-container" @click.stop>
                    <!-- Header -->
                    <div class="bast-modal-header d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <button
                                type="button"
                                class="back-btn mr-2"
                                @click="handleBack"
                                aria-label="Kembali"
                            >
                                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.44256 7.93462C6.61274 7.84281 6.71884 7.66823 6.71884 7.47835V4.52166H12.5569C12.8517 4.52166 13.0909 4.28797 13.0909 4.00002C13.0909 3.71207 12.8517 3.47837 12.5569 3.47837H6.71884V0.521683C6.71884 0.331108 6.61274 0.156531 6.44256 0.0654168C6.27239 -0.0270885 6.06447 -0.0208287 5.89999 0.0800228L0.249215 3.55836C0.0939897 3.65434 0 3.82057 0 4.00002C0 4.17947 0.0939897 4.3457 0.249215 4.44168L5.89999 7.92001C5.98686 7.97287 6.08583 8 6.1848 8C6.2731 8 6.3621 7.97774 6.44256 7.93462Z" fill="#111827"/>
                                </svg>
                            </button>
                            <h5 class="bast-modal-title mb-0">Konfirmasi BAST</h5>
                        </div>
                        <button type="button" class="btn btn-close-bast" @click="$emit('closeModal')">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                    <!-- Body -->
                    <div class="bast-modal-body">
                        <!-- Kode BAST -->
                        <div class="bast-form-row">
                            <label class="bast-form-label mb-0">Kode BAST</label>
                            <div class="bast-form-input">
                                <div class="bast-readonly-box">
                                    {{ data ? data.bast_no : '' }}
                                </div>
                            </div>
                        </div>

                        <!-- Nama Penerima -->
                        <div class="bast-form-row">
                            <label class="bast-form-label mb-0">Nama Penerima</label>
                            <div class="bast-form-input">
                                <input
                                    type="text"
                                    class="bast-input"
                                    v-model="form.receiver_name"
                                    placeholder=""
                                />
                            </div>
                        </div>

                        <!-- Tanda Tangan -->
                        <div class="bast-form-row align-top">
                            <label class="bast-form-label mb-0 pt-1">Tanda Tangan</label>
                            <div class="bast-form-input">
                                <div class="signature-box">
                                    <vue-signature-pad width="100%" height="116px" ref="signaturePad" />
                                    <button
                                        type="button"
                                        class="btn-clear-signature"
                                        @click="$refs.signaturePad.clearSignature()"
                                    >
                                        Hapus
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Actions -->
                        <div class="bast-actions-row d-flex justify-content-end align-items-center">
                            <button
                                type="button"
                                class="btn-bast-batal"
                                @click="$emit('closeModal')"
                            >
                                Batal
                            </button>
                            <button
                                type="button"
                                class="btn-bast-submit"
                                @click="submitForm"
                            >
                                Konfirmasi
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        data () {
            return {
                form: {
                    receiver_name: null,
                    receiver_signature: null,
                }
            }
        },
        props: ['data'],
        mounted () {

        },
        methods : {
            handleBack () {
                if (this.$listeners && this.$listeners.goBack) {
                    this.$emit('goBack');
                } else {
                    this.$emit('closeModal');
                }
            },
            isEmpty (val) {
                return val == null || val == '' || val.length == 0;
            },
            submitForm () {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

                let errors = [];
                if (isEmpty) {
                    errors.push("Signature is required");
                }

                if (this.isEmpty(this.form.receiver_name)) errors.push("Receiver Name is required");

                if (errors.length > 0) {
                    this.$swal.fire({
                        title: "Error",
                        html: `<p>> ${errors.join("<br>> ")}</p>`,
                        icon: "error",
                    });
                    return;
                }

                this.form.receiver_signature = data.split(",")[1];

                this.$http.post(`/api/qrs/receipt/${this.data.id}/confirm`, this.form)
                .then(()=>{
                    this.$swal.fire({
                        title: "Success",
                        text: "BAST has been confirmed",
                        icon: "success",
                    });
                    this.$emit('refreshData');
                    this.$emit('closeModal');
                })
                .catch((err)=>{console.log(err)})
            },
        }
    }
</script>

<style scoped>
.bast-modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    padding: 20px;
}

.bast-modal-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.bast-modal-container {
    width: 521px;
    max-width: 521px;
    min-height: 357px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    padding: 0;
    overflow: hidden;
    transform: rotate(0deg);
    opacity: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.bast-modal-header {
    height: 48px;
    padding: 12px 20px;
    border-bottom: 1px solid #F3F4F6;
    flex-shrink: 0;
    box-sizing: border-box;
}

.back-btn {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none;
    line-height: 1;
}

.bast-modal-title {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
}

.btn-close-bast {
    padding: 0;
    border: none;
    background: transparent;
    color: #111827;
    font-size: 16px;
    cursor: pointer;
    line-height: 1;
    outline: none;
    box-shadow: none;
}

.btn-close-bast:hover {
    color: #6B7280;
}

.bast-modal-body {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.bast-form-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.bast-form-row.align-top {
    align-items: flex-start;
}

.bast-form-label {
    width: 112px;
    min-width: 112px;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 600;
    color: #2F2F2F;
}

.bast-form-input {
    flex: 1;
    min-width: 0;
}

.bast-readonly-box {
    min-height: 30px;
    height: 30px;
    background-color: #F7F7F7;
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 14px;
    color: #2F2F2F;
    display: flex;
    align-items: center;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
}

.bast-input {
    height: 30px;
    border: 1px solid #E5E7EB;
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 14px;
    color: #2F2F2F;
    background-color: #FFFFFF;
    box-shadow: none;
    outline: none;
    width: 100%;
    box-sizing: border-box;
}

.bast-input:focus {
    border-color: #F36F21;
    box-shadow: 0 0 0 1px #F36F21;
}

.signature-box {
    border: 1px solid #E5E7EB;
    border-radius: 4px;
    position: relative;
    background: #FFFFFF;
    overflow: hidden;
    height: 118px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.signature-box canvas {
    display: block;
}

.btn-clear-signature {
    position: absolute;
    bottom: 8px;
    right: 12px;
    background: transparent;
    border: none;
    color: #ADADAD;
    font-size: 13px;
    cursor: pointer;
    padding: 0;
    outline: none;
    line-height: 1;
}

.btn-clear-signature:hover {
    color: #6B7280;
}

.bast-actions-row {
    margin-top: 0;
}

.btn-bast-batal {
    background: transparent;
    border: none;
    color: #F36F21;
    font-size: 14px;
    font-weight: 500;
    padding: 0;
    margin-right: 20px;
    box-shadow: none;
    cursor: pointer;
    outline: none;
    line-height: 1;
}

.btn-bast-batal:hover {
    color: #D95D16;
}

.btn-bast-submit {
    background-color: #F36F21;
    border: 1px solid #F36F21;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    width: 100px;
    height: 31px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    cursor: pointer;
    outline: none;
    line-height: 1;
    transition: background-color 0.2s, border-color 0.2s;
}

.btn-bast-submit:hover {
    background-color: #D95D16;
    border-color: #D95D16;
    color: #FFFFFF;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .bast-modal-container,
.modal-leave-active .bast-modal-container {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
}
</style>